import LoadingSpinner from '@carvana/loading-spinner';
import { useEffect } from 'react';
import type { Location, NavigateFunction } from 'react-router-dom';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import Api from '../../api';
import AppraisalSteps from '../AppraisalWizard/AppraisalSteps';
import { routes } from '../../utilities';
import { APP_BASE_PATH } from '../../utilities/appBasePath';

const Wrapper = styled.div`
  height: 500px;
`;

type NavigateFn = (id: string, navigate: NavigateFunction, location: Location) => void;

export type GetAppraisalDetailsForImpersonationResponse = {
  data: {
    content: {
      appraisalId: string;
      vehicleId?: string;
    };
  };
};

const getAppraisalDetails = async appraisalId =>
  new Api().appraisal.getAppraisalDetailsForImpersonation(appraisalId);

const goToAddVin: NavigateFn = (appraisalId, navigate, location) =>
  navigate(routes.toWithSearch(`${APP_BASE_PATH}/addvin/${appraisalId}`, location));

const goToResubmit: NavigateFn =
  (appraisalVehicleId, navigate, location, step: any = null) =>
  () => {
    const goToStep = AppraisalSteps[step] ? `/${AppraisalSteps[step]}` : '';
    navigate(
      routes.toWithSearch(`${APP_BASE_PATH}/offer/edit/${appraisalVehicleId}${goToStep}`, location)
    );
  };

export const redirect = async ({
  getAppraisalDetails,
  navigate,
  location,
  goToResubmit,
  goToAddVin,
  id
}: {
  getAppraisalDetails: (id: string) => Promise<GetAppraisalDetailsForImpersonationResponse>;
  goToAddVin: NavigateFn;
  goToResubmit: NavigateFn;
  navigate: NavigateFunction;
  location: Location;
  id: string;
}) => {
  try {
    const res = await getAppraisalDetails(id);
    const { appraisalId, vehicleId } = res.data.content;
    if (vehicleId) {
      goToResubmit(vehicleId, navigate, location);
    } else {
      goToAddVin(appraisalId, navigate, location);
    }
  } catch (error) {
    navigate(APP_BASE_PATH);
  }
};

const ImpersonationRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { id } = params ?? {};

  useEffect(() => {
    redirect({
      getAppraisalDetails,
      goToAddVin,
      goToResubmit,
      navigate,
      location,
      id
    });
  }, [getAppraisalDetails, goToAddVin, goToResubmit, navigate, location, id]);
  return (
    <Wrapper>
      <LoadingSpinner isLarge />
    </Wrapper>
  );
};

export default ImpersonationRouter;
